import {Box, Icon} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {smtpCredentialsTestStatus} from '../constants/smtpCredentialsTestStatus';
import {getSmtpTestStatusPresentation} from '../utils/getSmtpTestStatusPresentation';
import {isSmtpTestResultStatus} from '../utils/isSmtpTestResultStatus';

const RESULT_STATUSES = Object.values(smtpCredentialsTestStatus).filter(isSmtpTestResultStatus);

export function SmtpTestStatusIconPreload(props: TestIdProps) {
  return (
    <Box
      width={0}
      height={0}
      overflow="hidden"
      pointerEvents="none"
      data-testid={suffixTestId('iconPreload', props)}
    >
      {RESULT_STATUSES.map((status) => (
        <Icon
          key={status}
          value={getSmtpTestStatusPresentation(status).icon}
          size={4}
          data-testid={suffixTestId(`iconPreload-${status}`, props)}
        />
      ))}
    </Box>
  );
}
